const DefaultCompanyLogoURL = "https://firebasestorage.googleapis.com/v0/b/dropcard-test.appspot.com/o/bg%2Fdefault-logo.png";
const DefaultCompanyBGURL = "https://firebasestorage.googleapis.com/v0/b/dropcard-test.appspot.com/o/bg%2Fdefaul-bg.png" 

module.exports = {
	DefaultCompanyLogoURL,
	DefaultCompanyBGURL
};


// WEBPACK FOOTER //
// ./src/variables/Config.jsx